export default __webpack_public_path__ + "static/media/images4.335fee15.jpg";